import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Privacy from './component/privacy'
import NavBar from './component/navBar'
import Home from './component/home'
import Footer from './component/footer'

const App = () => {
  return (
    <Router >
      <NavBar />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/privacy">
          <Privacy />
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
}

export default App